export default {
  users: [],
  usersCount: 0,
  query: '',
  limit: 10,
  skip: 0
}
